import { useHistory, useLocation } from 'react-router-dom'

import { IconButton, Layout } from '@loadsmart/loadsmart-ui'

import { Icon } from 'core/ui/components/icon/Icon'

import {
  BidState,
  hasCarrierAcceptedRfp,
  isAwardFinished,
  type RfpSummary,
} from '../domain/RfpSummary'
import { getRfpBasePath } from './RfpRoute'
import { ActionButton } from './RfpSummaryListItemAction.styles'

export type RfpSummaryListItemActionProps = {
  rfpSummary: RfpSummary
}

export function RfpSummaryListItemAction({ rfpSummary }: RfpSummaryListItemActionProps) {
  const { bidState, carrierInviteState, inviteLinkUuid, awardedLaneProposalsCount } = rfpSummary

  const { push: navigate } = useHistory()
  const { pathname } = useLocation()
  const rfpPath = `${getRfpBasePath(pathname)}/${inviteLinkUuid}`

  function handleDetailsClick() {
    navigate(rfpPath)
  }

  function handleFeedback() {
    navigate(`${rfpPath}/feedback`)
  }

  function handleBidClick() {
    if (!hasCarrierAcceptedRfp(carrierInviteState)) {
      navigate(`${rfpPath}?accepted=true`)
      return
    }

    navigate(rfpPath)
  }

  function handleReviewClick() {
    if (isAwardFinished(carrierInviteState)) {
      navigate(`${rfpPath}/award/confirmation`)
      return
    }

    navigate(`${rfpPath}/award`)
  }

  if (bidState === BidState.Open) {
    return (
      <Layout.Group>
        <ActionButton onClick={handleBidClick} variant="primary">
          Bid
        </ActionButton>
      </Layout.Group>
    )
  }

  if (bidState === BidState.Results && awardedLaneProposalsCount > 0) {
    return (
      <Layout.Group align="center">
        <IconButton onClick={handleFeedback}>
          <Icon width={16} height={16} name="eye" />
        </IconButton>
        <ActionButton variant="primary" onClick={handleReviewClick}>
          Review
        </ActionButton>
      </Layout.Group>
    )
  }

  if (bidState === BidState.Closed) {
    return (
      <IconButton onClick={handleFeedback}>
        <Icon width={16} height={16} name="eye" />
      </IconButton>
    )
  }

  return (
    <IconButton onClick={handleDetailsClick}>
      <Icon width={16} height={16} name="eye" />
    </IconButton>
  )
}
